import { APIHOST } from '@/config/config'

//请求udesk需要的参数
export const udeskOnlineUrl = (params)=>{
  return window.$http({
    url: `${APIHOST}/cv/v3/cv_accounts/udesk_settings`,
    method: 'GET',
    params
  })
}

export async function dealSignatrue(params,privateKey) {
  params.nonce = new Date().getTime();
  
  let signature = getSignature(params, privateKey)
  params.signature = signature
  return params
}

export function getSignature (params, privateKey) {
  let md5 = require('js-md5')
  let str = ''

  const ordered = {}
  Object.keys(params).sort().forEach(function (key) {
    ordered[key] = params[key]
  })
  ordered.private_key = privateKey
  for (let key in ordered) {
    // 去掉空值参数
    if (ordered[key] || ordered[key] === 0) {
      if (str !== '') {
        str += '&'
      }
      str += key + '=' + ordered[key]
    }
  }
  return md5(str)
}